import { Button, SegmentedControl } from "@helmr/ui";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { NoAccess } from "../../app/NoAccess";
import { areaAllows } from "../../app/nav";
import { CalendarView } from "./CalendarView";
import { styles as c, useScope } from "./common";
import { TemplatesView } from "./TemplatesView";

export function ClassesPage() {
  const { ctx } = useScope();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "templates" ? "templates" : "calendar";
  if (ctx.status === "loading") return null;
  // The nav and this page share one guard (classes.view or pt.view); a role with PT only lands on the PT calendar.
  if (!areaAllows("classes", ctx.has)) return <NoAccess />;
  if (!ctx.has("classes.view")) return <Navigate to="/classes/pt" replace />;
  return (
    <div className={c.page}>
      <div className={c.head}>
        <div><h1>Classes</h1><p>Who is teaching what, and how full it is.</p></div>
        <div className={c.tools}>
          {!areaAllows("staff", ctx.has) ? <Button as={Link} to="/me/attendance">My attendance</Button> : null}
          {ctx.has("pt.view") ? <Button as={Link} to="/classes/pt">PT calendar</Button> : null}
          <SegmentedControl label="Classes view" value={tab} onChange={(v) => setParams(v === "templates" ? { tab: "templates" } : {})} options={[{ value: "calendar", label: "Calendar" }, { value: "templates", label: "Templates" }]} />
        </div>
      </div>
      {tab === "calendar" ? <CalendarView /> : <TemplatesView />}
    </div>
  );
}
